import { Wordmark } from '../components/Wordmark';
import { companyDetails, legalDocumentOrder, legalDocuments, legalLabels, type LegalDocumentId } from '../legalContent';

/** #legal/<id> — one legal document, the related ones, and the controller details (same layout as E-METAR's). */
export function Legal({ id }: { id: LegalDocumentId }) {
  const doc = legalDocuments[id];
  return (
    <main class="legal">
      {/* the mark IS the way home (Marc): same lockup as the front page, nothing else in the bar */}
      <header class="legal__top">
        <a class="legal__brand" href="/" aria-label="RoarDrive"><img class="brandmark brandmark--h" src="/logo.svg?v=1" alt="" /><Wordmark class="wordmark" /></a>
      </header>
      <article class="legal__doc">
        <div class="eyebrow">{legalLabels[id]}</div>
        <h1>{doc.title}</h1>
        <p class="legal__updated">{doc.updatedAt}</p>
        <p class="legal__intro">{doc.intro}</p>
        {doc.sections.map((s) => (
          <section key={s.heading}>
            <h2>{s.heading}</h2>
            {s.paragraphs?.map((p, i) => <p key={i}>{p}</p>)}
            {s.bullets && (
              <ul>
                {s.bullets.map((b, i) => <li key={i}>{b}</li>)}
              </ul>
            )}
          </section>
        ))}
      </article>
      <aside class="legal__side">
        <div class="eyebrow">Related documents</div>
        <ul class="legal__related">
          {legalDocumentOrder.filter((d) => d !== id).map((d) => (
            <li key={d}><a href={`/legal/${d}`}>{legalLabels[d]}</a></li>
          ))}
        </ul>
        <div class="eyebrow">Controller information</div>
        <ul class="legal__company">
          {companyDetails.map((line) => <li key={line}>{line}</li>)}
        </ul>
      </aside>
    </main>
  );
}
